import { render, staticRenderFns } from "./generalSettings.vue?vue&type=template&id=fb25e2e4"
import script from "./generalSettings.vue?vue&type=script&lang=js"
export * from "./generalSettings.vue?vue&type=script&lang=js"
import style0 from "./generalSettings.vue?vue&type=style&index=0&id=fb25e2e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports